import { render, staticRenderFns } from "./modal_agregarObservacion-quimico.vue?vue&type=template&id=9491b544&"
import script from "./modal_agregarObservacion-quimico.vue?vue&type=script&lang=js&"
export * from "./modal_agregarObservacion-quimico.vue?vue&type=script&lang=js&"
import style0 from "./modal_agregarObservacion-quimico.vue?vue&type=style&index=0&id=9491b544&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports